module.exports = __webpack_public_path__ + "fonts/Inter-BlackItalic.07e69b5.woff";